import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

class Loader extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				{this.props.showLoader &&
					<div className="loader loader-default is-active"></div>
				}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	showLoader: state.Loader.active
})


export default connect(mapStateToProps)(Loader)
